import { render, staticRenderFns } from "./BottomImage.vue?vue&type=template&id=e99a31fc&scoped=true&"
import script from "./BottomImage.vue?vue&type=script&lang=js&"
export * from "./BottomImage.vue?vue&type=script&lang=js&"
import style0 from "./BottomImage.vue?vue&type=style&index=0&id=e99a31fc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99a31fc",
  null
  
)

export default component.exports